import { createSlice } from '@reduxjs/toolkit';
import { deserialize } from 'deserialize-json-api';
// utils
import axios from '../../../utils/axios';
import { dispatch } from '../../store';

const initialState = {
    isLoading: false,
    metrics: {}
}

const slice = createSlice({
    name: "Monthly Deliveries Metrics",
    initialState,
    reducers: {
        // START LOADING
        startLoading(state) {
            state.isLoading = true;
        },
        // HAS ERROR
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },

        // STOP LOADING
        stopLoading(state) {
            state.isLoading = false;
        },

        getMonthlyDeliveriesMetricsSuccess(state, action) {
            const payload = action.payload
            const metrics = {
                deliveresWithErrorsThisMonth: payload.deliveres_with_errors_this_month,
                deliveriesWithNoErrorsThisMonth: payload.deliveries_with_no_errors_this_month,
                deliveriesWithErrorsLastMonth: payload.deliveries_with_errors_last_month,
                deliveriesWithNoErrorsLastMonth: payload.deliveries_with_no_errors_last_month,
                deliveriesWithNoErrorsTrend: payload.deliveries_with_no_errors_trend,
                deliveriesWithErrorsTrend: payload.deliveries_with_errors_trend
            };
            metrics.percentageChangeWithErrors = calculatePercentageDiff(metrics.deliveresWithErrorsThisMonth, metrics.deliveriesWithErrorsLastMonth) || 0;
            metrics.percentageChangeWithNoErrors = calculatePercentageDiff(metrics.deliveriesWithNoErrorsThisMonth, metrics.deliveriesWithNoErrorsLastMonth) || 0;
            state.metrics = metrics;
        }
    }
})


export default slice.reducer;

export function getMonthlyDeliveriesMetrics() {
    return async () => {
        try {
            let pathName = `/retailer_app/api/v1/retailers/monthly/deliveries_metrics`
            const response = await axios.get(pathName);
            const payload = response.data.data
            dispatch(slice.actions.getMonthlyDeliveriesMetricsSuccess(payload));
        } catch (error) {
            console.error(error);
        }
    }
}

function calculatePercentageDiff(thisMonth, lastMonth) {
    const difference = thisMonth - lastMonth;

    return parseFloat(((difference * 100) / (thisMonth || 1)).toFixed(2))
}